<template>
<b-row>
    <div class="fixed-top d-flex align-items-center justify-content-center" style="bottom: 0; overflow-y: auto">
      <b-col cols="12" md="4">
        <b-card title="Patient authentication" class="mb-2 text-left">
          <b-card-text>
            <b-alert v-if="message.length > 0" show variant="danger">{{ message }}</b-alert>
            <b-form @submit.prevent="validatePatient">
              <b-row>
                <Date v-on:custom-date="setDob" type="Date of Birth" :DOBPresent="DOBPresent"/>
              </b-row>
              <b-row>
                <b-col cols="12" class="mt-2">
                  <b-button type="submit" :disabled="isDisabled" variant="primary" data-cy="submit">Submit</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-text>
        </b-card>
      </b-col>
    </div>
</b-row>
</template>

<script>
import { VALIDATE_PATIENT, RESET_STATE} from "@/store/actions.type";
import { SET_IS_LOADING } from "@/store/mutations.type";
import store from "@/store"
import Date from "@/components/utils/Date.vue";
export default {
  props: ["survey", "education", "DOBPresent"],
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch(RESET_STATE),
      store.commit(SET_IS_LOADING, true),
      ]).then(() => {
        store.commit(SET_IS_LOADING, false)
      next();
    })
  },
  components:{
    Date
  },
  data() {
    return {
      dob: "",
      message: '',
    };
  },
  methods: {
    setDob(date) {
      this.dob = date ? date : "";
      if (this.DOBPresent && !this.isDisabled) {
        this.validatePatient();
      }
    },
    validatePatient() {
      if(this.dob.length > 1 && (this.education || this.survey)){
        this.$store.dispatch(VALIDATE_PATIENT,{slug:'verify', params:{ dob:this.dob,surveyLink:this.survey,educationLink:this.education}}).then(resp=>{
          if(resp.status ==200){
            this.$emit("valid-patient", {dob: this.dob, data: resp.data});
          }
          else{
            this.message = resp.data.errorMessage
          }
        })
      }
    },
  },
  computed: {
    isDisabled: function () {
      return this.dob.length < 10;
    },
  },
};
</script>

<style>
</style>